import Splide from '@splidejs/splide';

export default class NumberedCarousel {
	constructor(wrapper) {

		this.mainslides 			= wrapper.querySelector('.b-numbered-carousel__track');
		this.progressBar			= wrapper.querySelector('.b-numbered-carousel__progressbar');

		this.slider = new Splide(this.mainslides, 
		{
			type: 'slide',
			pagination: false,
			arrows: true,
			perPage: 3,
			perMove: 1,
			drag: true,
			gap: '32px',
			focus: 'left',
			trimSpace: true,
			padding: '160px',
			dragMinThreshold: 30,
			arrowPath: 'M28.7954 11.4754C28.771 11.4164 28.7348 11.3611 28.6869 11.3132C28.639 11.2653 28.5837 11.2291 28.5247 11.2047C28.4658 11.1802 28.4011 11.1667 28.3334 11.1667H28.3333H11.6667C11.3905 11.1667 11.1667 11.3906 11.1667 11.6667C11.1667 11.9429 11.3905 12.1667 11.6667 12.1667H27.1262L11.3131 27.9799C11.1179 28.1751 11.1179 28.4917 11.3131 28.687C11.5084 28.8822 11.825 28.8822 12.0202 28.687L27.8334 12.8739V28.3334C27.8334 28.6096 28.0572 28.8334 28.3334 28.8334C28.6095 28.8334 28.8334 28.6096 28.8334 28.3334V11.6677C28.8334 11.6643 28.8333 11.6609 28.8333 11.6575C28.8321 11.5955 28.8195 11.5336 28.7954 11.4754Z',
			easing: 'cubic-bezier(0, 0, 0, 1)',
			breakpoints: {
				1239: {
					padding: '100px',
				},
				1023: {
					perPage: 'auto',
					autoWidth: true,
					padding: '24px',
					gap: '24px',
				},
				640: {
					perPage: 'auto',
					autoWidth: true,
					gap: '24px',
				},
			}
		})

		this.slider.on( 'mounted move', () => {
			var end  = this.slider.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( this.slider.index + 1 ) / end, 1 );
			this.progressBar.style.width = String( 100 * rate ) + '%';
		} );
		
		this.slider.mount()

	}

	init() {

		

	}
}
